import apiClient from "./apiClient";
import { LiveBoardResponse } from "map/liveBoard";

/**
 * The live trips board snapshot: every open trip plus the hubs to draw.
 *
 * The BFF forwards OrderApi's answer verbatim, so the rows arrive under the board query's own
 * column names. Nothing is remapped on the way in -- see map/liveBoard.ts.
 */
const getBoard = async (hoursAhead: number): Promise<LiveBoardResponse> => {
  return apiClient.get(`/trips/live-board`, { hoursAhead });
};

const liveBoardService = {
  getBoard,
};

export default liveBoardService;
